// blurbs/weight-blurb.ts
import type { ICriticalReadingData } from '../types';

const line = (label: string, value: string): string => `${label}: ${value}\n`;

/**
 * @param touchpointAttempted true only when the MA actually clicked "Attempt now"
 *   and completed the Monthly Touchpoint. The monthly-interaction field can be
 *   pre-selected to "attempt-now" without the MA doing anything, so the touchpoint
 *   details must not appear on the note unless it was really attempted.
 */
export const buildWeightBlurb = (
  data: ICriticalReadingData,
  touchpointAttempted = false,
): string => {
  let t = '';
  t += line(
    'Runbook Entry Exists',
    data.weightRunbook === 'has-entry'
      ? `Yes — action entered: ${data.weightRunbookAction ?? ''}`
      : 'No — system default applied: Escalate to Clinic',
  );
  t += line(
    'Routine Monthly Interaction Completed This Month',
    data.weightMonthlyInteraction === 'completed' ? 'Yes' : 'No',
  );
  if (touchpointAttempted) {
    t += line('Monthly Interaction Attempted', 'Yes');
    // Consent / Communication Authorization Verification (from the Monthly Touchpoint).
    if (data.consent === 'patient') {
      t += line('Spoke With', 'Patient');
    } else if (data.consent === 'representative') {
      t += line('Spoke With', 'Representative');
      if (data.representativeName)
        t += line('Representative Name', data.representativeName);
      if (data.representativeRelationship)
        t += line('Relationship to Patient', data.representativeRelationship);
      if (data.representativeAttestation)
        t += line(
          'Attestation Obtained',
          data.representativeAttestation === 'yes' ? 'Yes' : 'No',
        );
    } else if (data.consent === 'unable-to-verify') {
      t += line('Spoke With', 'Unable to Verify Identity/Authorization');
    }
    if (data.weightTrendReviewed)
      t += line('Weight Trend Reviewed', data.weightTrendReviewed);
    if (data.wellnessCheckIn)
      t += line('General Wellness Check-In', data.wellnessCheckIn);
    if (data.barriersConcerns)
      t += line('Barriers/Concerns Reported', data.barriersConcerns);
    if (data.educationProvided)
      t += line('Education Provided', data.educationProvided);
  }
  return t.trim();
};
